// extracted by mini-css-extract-plugin
export default {"container":"HeaderList_container__alKiQ"};